import { useContext } from 'react';
import { AsyncResult, ALWAYS_LOADING } from '../types/AsyncResult';
import { ExperimentContext } from './ExperimentContext';
import { Experiment } from './types';

/** Asynchronously loads an experiment value (or serves it from the cache).
 * To skip loading the experiment, pass `null` instead. This will return the same value
 * as if the experiment just kept loading forever.
 */
export const useExperiment = <T>(experiment: Experiment<T> | null): AsyncResult<T> => {
  const requestExperiment = useContext(ExperimentContext);
  return experiment === null ? ALWAYS_LOADING : requestExperiment(experiment);
};
